/* unplugin-vue-components disabled */import script from "./AddTimer.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddTimer.vue?vue&type=script&lang=ts&setup=true"

import "./AddTimer.vue?vue&type=style&index=0&id=16592681&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16592681"]])

export default __exports__